import { render, staticRenderFns } from "./WidgetStatsCount.vue?vue&type=template&id=018f438a&scoped=true&"
import script from "./WidgetStatsCount.vue?vue&type=script&lang=js&"
export * from "./WidgetStatsCount.vue?vue&type=script&lang=js&"
import style0 from "./WidgetStatsCount.vue?vue&type=style&index=0&id=018f438a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018f438a",
  null
  
)

export default component.exports